/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faBuilding} from '@fortawesome/pro-duotone-svg-icons';

const BuildingIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faBuilding} {...props} />
);

export default BuildingIcon;
